import { useCallback } from "react";

export const useOneTrust = () => {
  const loadOTScript = useCallback((env: "test" | "prep" | "prod") => {
    let otSdkStub = document.createElement("script");
    otSdkStub.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    otSdkStub.type = "text/javascript";
    otSdkStub.setAttribute("data-document-language", "true");
    if (env === "test" || env === "prep") {
      otSdkStub.setAttribute(
        "data-domain-script",
        "94f2c3d0-5cfa-4ba2-92ed-8631caeff449"
      );
    } else {
      if (env === "prod") {
        otSdkStub.setAttribute(
          "data-domain-script",
          "94f2c3d0-5cfa-4ba2-92ed-8631caeff449"
        );
      }
    }
    document.getElementsByTagName("head")[0].appendChild(otSdkStub);
  }, []);

  return { loadOTScript };
};
